import { useContextSelector } from 'use-context-selector'

import { MovementsModalContext } from '../context/MovementsModalProvider'

export const useMovementsModal = () => {
  // TODO: is there a way to avoid this repetition for each prop of context?
  // Maybe something like a `pick` of props you want
  const close = useContextSelector(
    MovementsModalContext,
    (movementsModal) => movementsModal.close
  )

  const isOpen = useContextSelector(
    MovementsModalContext,
    (movementsModal) => movementsModal.isOpen
  )

  const open = useContextSelector(
    MovementsModalContext,
    (movementsModal) => movementsModal.open
  )

  const options = useContextSelector(
    MovementsModalContext,
    (movementsModal) => movementsModal.options
  )

  return {
    close,
    isOpen,
    open,
    options,
  }
}
